/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ConfigurationLocationModule } from './configuration-location.module';
export { ConfigurationLocationComponent } from './configuration-location.component';